import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=06750db6&scoped=true&"
import script from "./ManagementPage.vue?vue&type=script&lang=js&"
export * from "./ManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06750db6",
  null
  
)

export default component.exports